import React, { useState } from "react";
import axios from "axios";
import {
  Box,
  Typography,
  TextField,
  Button,
  Snackbar,
  Paper,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import theme from "../components/Theme";

const ReservationComponent = ({
  userId,
  placeId,
  authToken,
  isAuthenticated,
  refetchPlaceData,
  onClose,
}) => {
  const getApiBaseUrl = () => {
    // Always use production backend (onrender)
    return import.meta.env.VITE_ENVPROD || 'https://activitynavigator-backend.onrender.com';
  };
  const apiBaseUrl = getApiBaseUrl();
  const [dateBooked, setDateBooked] = useState("");
  const [startTime, setStartTime] = useState("");
  const [duration, setDuration] = useState(1);
  const [visitors, setVisitors] = useState(1);
  const [note, setNote] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [response, setResponse] = useState(null);

  const handleSubmit = async () => {
    try {
      const response = await axios.post(
        `${apiBaseUrl}/api/reservation`,
        {
          placeId,
          userId,
          date_booked: dateBooked,
          start_time: startTime,
          duration: duration,
          visitors: visitors,
          note: note,
        },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      setResponse(response.data);
      // Close dialog first
      if (onClose) {
        onClose();
      }
      // Show snackbar after dialog closes
      setTimeout(() => {
        setSnackbarOpen(true);
      }, 300);
      // Reset form
      setDateBooked("");
      setStartTime("");
      setDuration(1);
      setVisitors(1);
      setNote("");
      // Refetch place data
      if (refetchPlaceData) {
        refetchPlaceData();
      }
    } catch (error) {
      setResponse(error.response?.data);
      setSnackbarOpen(true);
      // Don't close dialog on error - let user see the error message
    }
  };

  return (
    <div>
      <Box>
        <Grid container spacing={2}>
          <Grid item xs={12} md={12} lg={12}>
            <Paper sx={{ p: 3 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <TextField
                    label="Date Booked"
                    type="date"
                    fullWidth
                    value={dateBooked}
                    onChange={(e) => setDateBooked(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <TextField
                    label="Start Time"
                    type="time"
                    fullWidth
                    value={startTime}
                    onChange={(e) => setStartTime(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <TextField
                    select
                    label="Duration"
                    fullWidth
                    value={duration}
                    onChange={(e) => setDuration(e.target.value)}
                    SelectProps={{
                      native: true,
                    }}
                  >
                    {[1, 2, 3, 4, 5].map((num) => (
                      <option key={num} value={num}>
                        {num}
                      </option>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <TextField
                    select
                    label="Visitors"
                    fullWidth
                    value={visitors}
                    onChange={(e) => setVisitors(e.target.value)}
                    SelectProps={{
                      native: true,
                    }}
                  >
                    {[...Array(25).keys()].map((num) => (
                      <option key={num + 1} value={num + 1}>
                        {num + 1}
                      </option>
                    ))}
                  </TextField>
                </Grid>
              </Grid>
              <TextField
                label="Note"
                multiline
                rows={4}
                fullWidth
                value={note}
                onChange={(e) => setNote(e.target.value)}
                sx={{ mt: 2 }}
              />
            </Paper>
          </Grid>
          <Grid item xs={12} md={12} lg={12} sx={{ textAlign: "center" }}>
            <Button
              variant="contained"
              onClick={handleSubmit}
              style={{ marginTop: "1rem" }}
              sx={{ backgroundColor: theme.palette.primary }}
            >
              Submit
            </Button>
          </Grid>
        </Grid>
      </Box>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={() => setSnackbarOpen(false)}
        message={response ? response.message : "Error submitting reservation"}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      />
    </div>
  );
};

export default ReservationComponent;
